// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"page-head"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20 7L20 3L4 3L4 7L20 7Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 7L20 3L4 3L4 7L20 7Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20 22L20 11L4 11L4 22","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-page-head')
export default class PageHeadIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'page-head',
    }
  }
}
